/* SubscriptionCard.module.css */

.card {
    border-radius: 8px;
    border: 1px solid var(--static-divider-standard);
    background-color: var(--static-background-strong);
    padding: 1rem;
    margin-bottom: 1rem;
    overflow: hidden;
    width: 100%;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    /* margin-bottom: 1.5rem; */
  }
  
  .titleRow {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.25rem;
  }
  
  .title {
    font-size: var(--fs-small-heading);
    color: var(--static-text-strong);
    font-weight: 500;
  }
  
  .activeStatus {
    display: flex;
    align-items: center;
    color: var(--sentiment-text-positive);
    font-size: var(--fs-small);
  }
  
  .activeStatus::before {
    content: "";
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: var(--sentiment-text-positive);
    margin-right: 0.375rem;
  }

  .canceledStatus {
    display: flex;
    align-items: center;
    color: var(--sentiment-text-positive);
    font-size: var(--fs-small);
  }
  
  .canceledStatus::before {
    content: "";
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: var(--sentiment-text-negative);
    margin-right: 0.375rem;
  }
  
  .billingCycle {
    font-size: var(--fs-small);
    color: var(--static-text-standard);
  }
  
  .upgradeButton {
    background-color: var(--primary-enabled);
    color: var(--primary-enabled-text);
    border: none;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-size: var(--fs-normal);
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .upgradeButton:hover {
    background-color: var(--primary-hover);
  }
  
  .upgradeButton:active {
    background-color: var(--primary-active);
  }
  
  .infoGrid {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 0.75rem 1.5rem;
    margin-bottom: 1.5rem;
    font-size: var(--fs-small);
  }
  
  .infoLabel {
    color: var(--static-text-strong);
    font-weight: 600;
  }
  
  .invoiceLink {
    color: var(--color-primary);
    cursor: pointer;
    font-weight: 600;
  }
  
  .invoiceLink:hover {
    text-decoration: underline;
  }
  
  .nextInvoice {
    /* background-color: var(--static-background-weak); */
    border: 1px solid var(--static-divider-standard);
    border-radius: 12px;
    /* padding: 1rem; */
    margin-bottom: 1.5rem;
  }
  
  .nextInvoiceTitle {
    font-size: infovar(--fs-normal);
    color: var(--static-text-strong);
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .lineItems {
    /* margin-bottom: 1rem; */
    border-bottom: 1px solid var(--static-divider-standard);
    /* padding-bottom: 1rem; */
  }
  
  .lineItem {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    font-size: var(--fs-small);
    /* margin-bottom: 0.5rem; */
  }
  
  .lineItemDescription {
    color: var(--static-text-standard);
  }
  
  .lineItemPrice {
    font-weight: 600;
    color: var(--static-text-strong);
  }
  
  .totalRow {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    padding: 1rem;
    background: var(--sentiment-background-info);
  }
  
  .totalLabel {
    color: var(--static-text-strong);
  }
  
  .totalAmount {
    color: var(--static-text-strong);
    font-weight: 600;
  }
  
  .footer {
    display: flex;
    justify-content: center;
  }
  
  .cancelButton {
    color: var(--static-text-standard);
    background: none;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-size: var(--fs-normal);
    transition: color 0.2s;
  }
  
  .cancelButton:hover {
    color: var(--sentiment-text-negative);
  }

  .nextInvoiceHeader {
    padding: 1rem;
  }